import axios from './api';

const API_URL = '/comptes-rendus/';

const createCompteRendu = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};


const getById = async (id) => {
  const response = await axios.get(API_URL+'/event/' + id);
  return response.data;
};

const getAll = async() => {
  const response = await axios.get(API_URL);
  return response.data;
};

const DeleteCompteRendu = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const updateCompteRendu = async (id,data) => {
  const response = await axios.patch(API_URL+id,data);
  return response.data;
};

const CompteRenduService = {
  updateCompteRendu,
  DeleteCompteRendu,
  getAll,
  getById,
  createCompteRendu
};

export default CompteRenduService;
